module.exports = {
  flexDirection: {
    value: 'column',
  },
};
